<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18.5H12" stroke="currentColor" stroke-linecap="round"/>
        <path d="M11 10L15 8M11 10L7 8M11 10V14M15 8L11 6L7 8M15 8V12L11 14M7 8V12L11 14" stroke="currentColor" stroke-linecap="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 2C5.67157 2 5 2.67157 5 3.5V7L6 6.5V3.5C6 3.22386 6.22386 3 6.5 3H15.5C15.7761 3 16 3.22386 16 3.5V6.5L17 7V3.5C17 2.67157 16.3284 2 15.5 2H6.5ZM17 13L16 13.5V16H11H6V13.5L5 13V16.5V19.5C5 20.3284 5.67157 21 6.5 21H15.5C16.3284 21 17 20.3284 17 19.5V16.5V13ZM6 19.5V17H16V19.5C16 19.7761 15.7761 20 15.5 20H6.5C6.22386 20 6 19.7761 6 19.5Z" fill="currentColor"/>
        <path d="M3 8L1.24807 9.16795C0.654342 9.56377 0.654342 10.4362 1.24808 10.8321L3 12" stroke="currentColor" stroke-linecap="round"/>
        <path d="M19 8L20.7519 9.16795C21.3457 9.56377 21.3457 10.4362 20.7519 10.8321L19 12" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGAR',
};
</script>

<style scoped lang="scss">

</style>
